import MessageBox from '../userMessages/messageBox';

// Spells out exactly what APPLY will do before anything reaches the device.
// describeHeater is optional: the panel supplies one that appends the spec
// figures, so the admin confirms against numbers rather than bare codes.
const ConfirmSummary = ({
  changes,
  describeHeater = (partNumber) => partNumber,
  onConfirm,
  onCancel,
}) => {
  const messages = [
    ...changes.toAdd.map((partNumber) => `add ${describeHeater(partNumber)}`),
    ...changes.toDelete.map(
      (partNumber) => `remove ${describeHeater(partNumber)}`,
    ),
  ];

  return (
    <MessageBox
      title='confirm heater changes'
      messages={messages}
      actions={[
        { name: 'cancel', onClick: onCancel },
        { name: 'confirm', onClick: onConfirm },
      ]}
    />
  );
};

export default ConfirmSummary;
